import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState } from 'react';
import classnames from 'classnames';
import { Theme } from "../../Background/Theme/Theme";
import { HeadingText } from "../../Text/HeadingText/HeadingText";
import { Text } from "../../Text/Text/Text";
import { WebVideo } from "../WebVideo/WebVideo";
import { Breakpoint } from "../../Responsive/Breakpoint/Breakpoint";
import styles from "./VideoPlayer.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var VideoPlayer = function VideoPlayer(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$caption = _ref.caption,
    caption = _ref$caption === void 0 ? '' : _ref$caption,
    video = _ref.video,
    _ref$onPlay = _ref.onPlay,
    onPlay = _ref$onPlay === void 0 ? function () {} : _ref$onPlay,
    _ref$onPause = _ref.onPause,
    onPause = _ref$onPause === void 0 ? function () {} : _ref$onPause,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? false : _ref$inline,
    _ref$cardActionAttrib = _ref.cardActionAttributes,
    cardActionAttributes = _ref$cardActionAttrib === void 0 ? {} : _ref$cardActionAttrib,
    aspectRatio = _ref.aspectRatio,
    _ref$videoHeight = _ref.videoHeight,
    videoHeight = _ref$videoHeight === void 0 ? 700 : _ref$videoHeight,
    _ref$videoWidth = _ref.videoWidth,
    videoWidth = _ref$videoWidth === void 0 ? 100 : _ref$videoWidth;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    playing = _useState2[0],
    setPlaying = _useState2[1];
  var onVideoPlay = function onVideoPlay() {
    setPlaying(true);
    onPlay();
  };
  var onVideoPause = function onVideoPause() {
    onPause();
  };
  var renderVideoAndTheme = function renderVideoAndTheme(breakpoint) {
    return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
      className: classnames(styles.videoPlayer, inline ? styles.inline : '')
    }, cardActionAttributes), {}, {
      style: breakpoint === 'desktop' ? aspectRatio === 'square' ? {
        width: "".concat(videoHeight, "px")
      } : aspectRatio === 'vertical' ? {
        width: "".concat(9 / 16 * videoHeight, "px")
      } : {
        width: "".concat(videoWidth, "%")
      } : {},
      children: [video && /*#__PURE__*/_jsx(WebVideo, _objectSpread(_objectSpread({}, video), {}, {
        onPlay: onVideoPlay,
        onPause: onVideoPause,
        aspectRatio: aspectRatio
      })), /*#__PURE__*/_jsx(Theme, {
        theme: "darkBackground",
        children: title && !playing && /*#__PURE__*/_jsx("div", {
          className: styles.title,
          children: /*#__PURE__*/_jsx(HeadingText, {
            align: "left",
            typog: "headline5",
            children: title
          })
        })
      })]
    }));
  };
  return /*#__PURE__*/_jsxs("div", {
    className: playing ? styles.playing : '',
    children: [/*#__PURE__*/_jsxs(Breakpoint, {
      breakpoint: "small",
      children: [renderVideoAndTheme('mobile'), renderVideoAndTheme('desktop')]
    }), caption && /*#__PURE__*/_jsx("div", {
      className: styles.caption,
      children: /*#__PURE__*/_jsx(Text, {
        className: styles.captionText,
        typog: "bodycopy",
        richText: true,
        children: caption
      })
    })]
  });
};